import React from 'react';
import Page from '../../components/Page';
import AccountProgress from '../../components/AccountProgress';
import { Icon, Breadcrumb, Table, Tab, Button, Modal, TextArea, Checkbox } from 'semantic-ui-react';
import { Link, Prompt, Route, matchPath, NavLink } from 'react-router-dom';
import useFetch from 'use-http';
import { Formik, FastField, Field, FieldArray } from 'formik';
import _ from 'lodash';
import { BooleanInput, TableLine, FormDropdown, TextInput, DropdownInput, MaterialTextArea } from './inputs';
// eslint-disable-next-line
import styled from 'styled-components/macro';
import MyMenu from './menu';
import Hours from './hours.json';
import Timezone from './timezone.json';
import { useTranslation } from 'react-i18next';
import SpecialDaysTab from './modules/specialDays';

const fetch_config = { responseType: 'json', cachePolicy: 'no-cache' };

const hours = Hours;
function AgentSecretnConfigs() {
	const { t } = useTranslation();
	return (
		<Tab.Pane>
			<Table definition>
				<Table.Header>
					<Table.Row>
						<Table.HeaderCell width={2} />
						<Table.HeaderCell>{t('value')}</Table.HeaderCell>
					</Table.Row>
				</Table.Header>

				<Table.Body>
					<TableLine title={t('phoneMask')} description={t('phoneMaskDesc')}>
						<BooleanInput name="agent.hide_phone_view" />
					</TableLine>
				</Table.Body>
			</Table>
		</Tab.Pane>
	);
}
function AgentScreenConfigs() {
	const { t } = useTranslation();
	return (
		<Tab.Pane>
			<Table definition>
				<Table.Header>
					<Table.Row>
						<Table.HeaderCell width={2} />
						<Table.HeaderCell>{t('value')}</Table.HeaderCell>
					</Table.Row>
				</Table.Header>

				<Table.Body>
					<TableLine title={t('emojiSupport')} description={t('emojiSupportDesc')}>
						<BooleanInput name="agent.emoji" />
					</TableLine>
					<TableLine title={t('mediaSupport')} description={t('mediaSupportDesc')}>
						<BooleanInput name="agent.attach" />
					</TableLine>
					<TableLine title={t('muteMessageSounds')} description={t('muteMessageSoundsDesc')}>
						<BooleanInput name="agent.silent_agent" />
					</TableLine>
					<TableLine title={t('textSelectPopup')} description={t('textSelectPopupDesc')}>
						<BooleanInput name="agent.selectpopup" />
					</TableLine>
					<TableLine title={t('enableSendStarting')} description={t('enableSendStartingDesc')}>
						<BooleanInput name="agent.showSendStart" />
					</TableLine>
					<TableLine title={t('agentSellingData')} description={t('agentSellingDataDesc')}>
						<BooleanInput name="agent.agentSellingData" />
					</TableLine>
				</Table.Body>
			</Table>
		</Tab.Pane>
	);
}
function TimeConfigs(props) {
	const { t } = useTranslation();
	let values = props.values || {};
	return (
		<Tab.Pane>
			<Table definition>
				<Table.Header>
					<Table.Row>
						<Table.HeaderCell width={2} />
						<Table.HeaderCell>{t('value')}</Table.HeaderCell>
					</Table.Row>
				</Table.Header>

				<Table.Body>
					<TableLine title={t('Offline Mode')} description={t('offlineModeDescription')}>
						<BooleanInput name="workingHours.offline" />
					</TableLine>
					{values.workingHours && values.workingHours.offline ? <TableLine warning description={t('offlineModeWarning')}></TableLine> : ''}
				</Table.Body>
			</Table>
			<Table definition>
				<Table.Header>
					<Table.Row>
						<Table.HeaderCell width={2} />
						<Table.HeaderCell>{t('value')}</Table.HeaderCell>
					</Table.Row>
				</Table.Header>

				<Table.Body>
					<TableLine title="UTC" single>
						<DropdownInput name="workingHours.timezone" list={Timezone}></DropdownInput>
					</TableLine>
					<TableLine title={t('monday')} single>
						<TimeInputLine name="workingHours.d1" number="d1"></TimeInputLine>
					</TableLine>
					<TableLine title={t('tuesday')} single>
						<TimeInputLine name="workingHours.d2" number="d2"></TimeInputLine>
					</TableLine>
					<TableLine title={t('wednesday')} single>
						<TimeInputLine name="workingHours.d3" number="d3"></TimeInputLine>
					</TableLine>
					<TableLine title={t('thursday')} single>
						<TimeInputLine name="workingHours.d4" number="d4"></TimeInputLine>
					</TableLine>
					<TableLine title={t('friday')} single>
						<TimeInputLine name="workingHours.d5" number="d5"></TimeInputLine>
					</TableLine>
					<TableLine title={t('saturday')} single>
						<TimeInputLine name="workingHours.d6" number="d6"></TimeInputLine>
					</TableLine>
					<TableLine title={t('sunday')} single>
						<TimeInputLine name="workingHours.d0" number="d0"></TimeInputLine>
					</TableLine>
				</Table.Body>
			</Table>
		</Tab.Pane>
	);
}
const WelcomeTypes = [
	{ value: 'text', text: 'Text' },
	{ value: 'payload', text: 'Payload' },
];
function WelcomeInputLine(props) {
	const { t } = useTranslation();
	return (
		<Field name={props.name}>
			{({ field, form }) => {
				let current = field.value || { type: 'text', text: '' };
				if (!current.type) current.type = 'text';
				return (
					<div
						css={`
							display: flex;
							.yt-line {
								margin-right: 5px;
							}
							margin: 10px 0;
						`}
					>
						<FormDropdown
							className="yt-line"
							placeholder={props.placeholder || t('select')}
							inline
							value={current.type}
							onChange={(e, { value }) => {
								if (current.type === value) return;
								let base = { type: value };
								base[value] = current[value === 'text' ? 'payload' : 'text'] || '';
								form.setFieldValue(props.name, base);
							}}
							scrolling
							compact
							options={WelcomeTypes}
						/>
						<MaterialTextArea
							css={`
								height: 22px;
							`}
							type={props.type || 'text'}
							name={field.name}
							placeholder={props.placeholder || '...'}
							value={current[current.type] || ''}
							onChange={(e, { value }) => {
								current[current.type] = value;
								form.setFieldValue(props.name, current);
							}}
						/>
					</div>
				);
			}}
		</Field>
	);
}

function TimeInputLine(props) {
	let base_name = props.name;
	return (
		<FieldArray
			name={`${base_name}.times`}
			render={(arrayHelpers) => {
				let array = _.get(arrayHelpers.form.values, arrayHelpers.name) || [];
				return (
					<div className="d-flex">
						<FastField name={`${base_name}.active`}>
							{({ field, form }) => (
								<Checkbox
									toggle
									onChange={(e, { checked }) => {
										form.setFieldValue(field.name, checked);
									}}
									onClick={() => {
										if (!field.value) {
											if (
												!(
													form.values.workingHours &&
													form.values.workingHours[props.number] &&
													form.values.workingHours[props.number].times &&
													form.values.workingHours[props.number].times.length
												)
											) {
												arrayHelpers.push({ start: 540, finish: 1080 });
											}
										}
									}}
									style={{ marginRight: '10px' }}
									checked={field.value}
								/>
							)}
						</FastField>
						<div>
							{_.map(array, (time, index) => (
								<div className="d-flex" key={index}>
									<div style={{ marginRight: '20px', marginBottom: '7px' }}>
										<DropdownInput name={`${arrayHelpers.name}.${index}.start`} list={hours} />
									</div>
									<div style={{ marginRight: '20px', marginBottom: '7px' }}>
										<DropdownInput name={`${arrayHelpers.name}.${index}.finish`} list={hours} />
									</div>

									<Button
										type="button"
										icon
										color="red"
										size="tiny"
										onClick={() => arrayHelpers.remove(index)}
										style={{ height: '22px', alignItems: 'center', display: 'flex' }}
									>
										<Icon name="x" />
									</Button>
								</div>
							))}

							<Button
								type="button"
								size="tiny"
								icon
								color="green"
								onClick={() => arrayHelpers.push({ start: 540, finish: 1080 })}
								style={{ height: '22px', alignItems: 'center', display: 'flex' }}
							>
								<Icon name="plus" />
							</Button>
						</div>
					</div>
				);
			}}
		/>
	);
}
function WelcomeInput(props) {
	const { t } = useTranslation();
	return (
		<FastField name={props.name}>
			{({ field }) => (
				<Table definition>
					<Table.Header>
						<Table.Row>
							<Table.HeaderCell width={2}>
								<b>{props.title}</b>
							</Table.HeaderCell>
							<Table.HeaderCell>{t('value')}</Table.HeaderCell>
						</Table.Row>
					</Table.Header>
					<Table.Body>
						<TableLine title={t('offlineMessage')} single>
							<WelcomeInputLine name={field.name + '.offlineMessage'} />
						</TableLine>
						<TableLine title={t('welcomeMessage')} single>
							<WelcomeInputLine name={field.name + '.welcomeMessage'} />
						</TableLine>
					</Table.Body>
				</Table>
			)}
		</FastField>
	);
}
function DefaultLanguage(props) {
	const { t } = useTranslation();
	let languages = [
		{
			text: t('turkish'),
			value: 'tr',
		},
		{ text: t('english'), value: 'en' },
	];
	return (
		<FastField name={props.name}>
			{({ field }) => (
				<Table definition>
					<Table.Header>
						<Table.Row>
							<Table.HeaderCell width={2}>
								<b>{props.title}</b>
							</Table.HeaderCell>
							<Table.HeaderCell>{t('value')}</Table.HeaderCell>
						</Table.Row>
					</Table.Header>
					<Table.Body>
						<TableLine title={t('defaultLanguage')} description={t('defaultLanguageDesc')}>
							<DropdownInput name="messageSetting.default" list={languages} />
						</TableLine>
						<TableLine title={t('hidePlatform', { type: 'WhatsApp' })} description={t('hidePlatformDesc', { type: 'WhatsApp' })}>
							<BooleanInput name="messageSetting.hide_whatsapp" />
						</TableLine>
						<TableLine title={t('hidePlatform', { type: 'Facebook' })} description={t('hidePlatformDesc', { type: 'Facebook' })}>
							<BooleanInput name="messageSetting.hide_facebook" />
						</TableLine>
						<TableLine title={t('hidePlatform', { type: 'Instagram' })} description={t('hidePlatformDesc', { type: 'Instagram' })}>
							<BooleanInput name="messageSetting.hide_instagram" />
						</TableLine>
						<TableLine title={t('hidePlatform', { type: 'Telegram' })} description={t('hidePlatformDesc', { type: 'Telegram' })}>
							<BooleanInput name="messageSetting.hide_telegram" />
						</TableLine>
						<TableLine title={t('hidePlatform', { type: 'Web' })} description={t('hidePlatformDesc', { type: 'Web' })}>
							<BooleanInput name="messageSetting.hide_web" />
						</TableLine>
					</Table.Body>
				</Table>
			)}
		</FastField>
	);
}

function WelcomeConfigs() {
	return (
		<Tab.Pane>
			<DefaultLanguage></DefaultLanguage>
			<WelcomeInput title="English" name="messageSetting.en" />
			<WelcomeInput title="Türkçe" name="messageSetting.tr" />
		</Tab.Pane>
	);
}

const ModalWrap = styled.div`
	color: black;
	padding: 0 16px 16px;
`;

const select_colors = {
	amount: '#21ba45',
	code: '#fbbd08',
	quantity: '#2185d0',
};
const Select = styled.div`
	display: inline-block;
	margin: 5px 5px 5px 0;
	padding: 8px 10px;
	border: 1px solid #eee;
	cursor: pointer;
	background: ${(props) => (props.color ? select_colors[props.color] || '#eee' : '#fff')};
	color: ${(props) => (props.color ? '#fff' : '#000')};
	user-select: none;
`;

const ButtonLine = styled.div`
	padding-top: 16px;
	border-top: 1px solid #eee;
	margin-top: 16px;
	display: flex;
`;

function generateList(text) {
	return _.map((text || '').split('\n'), (it) => it.split(/\s+/));
}

function PartSelector(props) {
	const { t } = useTranslation();
	const LABELS = [
		{ key: 'amount', label: t('price'), color: 'green', parse: 'float' },
		{ key: 'code', label: t('code'), color: 'yellow' },
		{ key: 'quantity', label: t('Count'), color: 'blue', parse: 'int' },
	];
	const [selected, setSelected] = React.useState((props.selected && props.selected.selected) || {});
	const [current, setCurrent] = React.useState(LABELS[0].key);
	const list = React.useMemo(() => {
		return generateList(props.value);
	}, [props.value]);

	function change(i, j) {
		let item = selected[current];
		let isCurrent = item && item[0] === i && item[1] === j;
		let key = `${i}-${j}`;
		let isActive = selected[key] && selected[key][2] === current;
		let state = [i, j, current];
		let next = { ...selected, [key]: isActive ? '' : state, [current]: state };
		if (item && !isCurrent) next[`${item[0]}-${item[1]}`] = '';
		if (isCurrent && isActive) next[current] = '';
		//console.log(current, item && !isCurrent, item, selected);

		setSelected(next);
		if (props.onChange) props.onChange({ list, selected: next });
	}

	function button_click(e, data) {
		setCurrent(data.name);
	}

	return (
		<div>
			<Button.Group>
				{_.map(LABELS, (it) => (
					<Button type="button" key={it.key} name={it.key} color={it.color} basic={current !== it.key} onClick={button_click}>
						{it.label}
					</Button>
				))}
			</Button.Group>
			<div
				css={`
					margin-top: 10px;
				`}
			>
				{_.map(list, (line, i) => (
					<div key={i}>
						{_.map(line, (val, j) => {
							let isActive = selected[`${i}-${j}`];
							return (
								<Select key={`${i}-${j}`} color={isActive && isActive[2]} onClick={() => change(i, j)}>
									{val}
								</Select>
							);
						})}
					</div>
				))}
			</div>
		</div>
	);
}

//no:\s?(TS.*?)(?:\n|$)Sipari[sş] tutarı:s?(.*?)(?:\n|$)

function generateRegex(found, list, main_text) {
	let last_point = { i: -1, j: -1 };
	let current_reg = '';
	const empty = '(?:\\n|.)*?';

	function compare(x, y) {
		if (x.i === y.i && x.j + 1 === y.j) return true;
		if (x.i === y.i + 1 && y.j === 0 && x.j === list[x.i].length - 1) return true;
	}
	let nfound = _.map(found, (it, x) => {
		let { i, j, text } = it;
		let ci = i,
			cj = j,
			ctext = '';
		let fark = compare(last_point, it);
		function handle() {
			if (cj > 0) cj--;
			else if (ci > 0) {
				ci--;
				let line = list[ci];
				cj = line.length - 1;
			}
			//console.log('handle', i, j, ci, cj);
		}
		handle();
		let trc_count = 1;
		if (fark) {
			last_point = it;
			if (current_reg) current_reg += empty;
			let reg_text = '\\s?(.*?)(?:\\s|\\n|$)';
			current_reg += reg_text;
			return { ...it, reg: reg_text };
		} else
			while (ci > last_point.i || (ci === last_point.i && cj > last_point.j)) {
				let reg = list[ci][cj],
					reg_text;
				if (i === 0 && j === 0) {
					ctext = `^[\\s\\n]*?${ctext}`;
					if (j === 0 && list[i].length > 1) {
						let next = list[i][j + 1];
						reg_text = `${ctext}\\s?(.*?)\\s?${next}`;
					} else reg_text = `${ctext}\\s?(.*?)(?:\\s|\\n|$)`;
				} else {
					if (ctext) ctext = `${reg}[\\s\\n]*?${ctext}`;
					else ctext = reg;
					reg_text = `${ctext}\\s?(.*?)(?:\\s|\\n|$)`;
				}
				let test_reg = new RegExp(current_reg ? current_reg + empty + reg_text : reg_text, 'i');
				let test_result = main_text.match(test_reg);
				test_result = test_result && test_result[x + 1];
				//console.log(test_reg, test_result);
				if (test_result === text) {
					last_point = it;
					if (current_reg) current_reg += empty;
					current_reg += reg_text || '()';
					return { ...it, reg: reg_text };
				}
				if (ci !== 0 && cj !== 0) handle();
				trc_count++;
				if (trc_count > 50) break;
			}
		if (current_reg) current_reg += empty;
		current_reg += '()';
		last_point = it;
	});
	//console.log(nfound);
	let reg = _.map(nfound, (it) => (it && it.reg) || '()').join(empty);
	//console.log('test', reg, main_text.match(new RegExp(reg)));
	return reg;
}

const LABELS = [{ key: 'amount' }, { key: 'code' }, { key: 'quantity' }];

function RegexPreview(props) {
	const { t } = useTranslation();

	const regex = React.useMemo(() => {
		let found = [];
		let { selected, list } = props.selected || {};
		if (!selected || !list) return;
		_.each(LABELS, (label) => {
			let item = selected[label.key];
			if (!item) return;
			let [i, j] = item;
			let text = list[i] && list[i][j];
			if (text) found.push({ i, j, text, key: label.key });
		});
		found = _.sortBy(found, ['i', 'j']);
		let reg = generateRegex(found, list, props.value);
		let res = props.value.match(new RegExp(reg));
		let result = {};
		_.each(found, (it, i) => (result[it.key] = res[i + 1]));
		return { text: props.value, reg, result, found };
	}, [props.selected, props.value]);

	return (
		<ModalWrap>
			{/* <pre>{JSON.stringify(regex, null, 2)}</pre> */}
			{regex ? (
				<div
					css={`
						display: flex;
						b {
							margin-right: 5px;
							text-transform: capitalize;
						}
						> div {
							flex: 1;
						}
						pre {
							margin: 0;
							border: 1px solid #f2711c;
							display: inline-block;
							padding: 16px;
						}
					`}
				>
					<div>
						<h3>{t('exampleMessage')}</h3>
						<pre>{regex.text}</pre>
					</div>
					<div>
						<h3>{t('variablesFound')}</h3>
						<pre>
							{_.map(regex.result, (val, key) => (
								<div key={key}>
									<b>{key}:</b>
									{val}
								</div>
							))}
						</pre>
					</div>
				</div>
			) : (
				t('couldNotAnything')
			)}
			<ButtonLine>
				<Button type="button" onClick={() => props.setStep(1)}>
					{t('return')}
				</Button>
				<Button className="ml-auto" type="button" onClick={() => props.setModal(false)}>
					{t('cancel')}
				</Button>
				<Button type="button" color="green" onClick={() => props.save(regex)}>
					{t('save')}
				</Button>
			</ButtonLine>
		</ModalWrap>
	);
}

function CloseParseModal(props) {
	const { t } = useTranslation();
	//const [init, setInit] = React.useState(props.value && props.value.text);
	const [modal, setModal] = React.useState(false);
	const [step, setStep] = React.useState(props.value && props.value.text ? 1 : 0);
	const [selected, setSelected] = React.useState();
	const [example, setExample] = React.useState((props.value && props.value.text) || '');
	const real_selected = React.useMemo(() => {
		if (selected) return selected;
		if (props.value && props.value.found) {
			let f = props.value && props.value.found;
			let selected = {};
			_.each(f, (it) => {
				selected[it.key] = [it.i, it.j, it.key];
				selected[`${it.i}-${it.j}`] = [it.i, it.j, it.key];
			});
			return { list: generateList(example), selected };
		}
	}, [selected, props.value, example]);
	function ExampleOnchange(e, { value }) {
		setExample(value);
		if (selected) setSelected(null);
	}

	function save(reg) {
		props.form.setFieldValue('agent.__close_parse_config_data', reg);
		setModal(false);
	}

	const CONFIG_PANES = [
		{
			menuItem: {
				content: t('exampleText'),
				key: 'step0',
			},
			render: () => (
				<ModalWrap>
					{t('successfulPaymentMessage')}
					<div className="ui form" style={{ marginTop: 10 }}>
						<TextArea value={example} onChange={ExampleOnchange} />
					</div>
					<ButtonLine>
						<Button type="button" color="teal" onClick={() => setStep(1)}>
							{t('nextStep')}
						</Button>
						<Button className="ml-auto" type="button" onClick={() => setModal(false)}>
							{t('cancel')}
						</Button>
					</ButtonLine>
				</ModalWrap>
			),
		},
		{
			menuItem: {
				content: t('selectLabels'),
				key: 'step1',
			},
			render: () => (
				<ModalWrap>
					<PartSelector value={example} selected={real_selected} onChange={setSelected} />
					<ButtonLine>
						<Button type="button" onClick={() => setStep(0)}>
							{t('return')}
						</Button>
						<Button type="button" color="teal" onClick={() => setStep(2)}>
							{t('nextStep')}
						</Button>
						<Button className="ml-auto" type="button" onClick={() => setModal(false)}>
							{t('cancel')}
						</Button>
					</ButtonLine>
				</ModalWrap>
			),
		},
		{
			menuItem: {
				content: t('preview'),
				key: 'step2',
			},
			render: () => <RegexPreview setStep={setStep} save={save} setModal={setModal} value={example} selected={real_selected} />,
		},
	];
	return (
		<Modal
			open={modal}
			trigger={
				<Button onClick={() => setModal(true)} color="orange" type="button">
					{t('openInteractiveEditor')}
				</Button>
			}
			centered={false}
		>
			<Tab menu={{ secondary: true, pointing: true }} activeIndex={step} panes={CONFIG_PANES} />
		</Modal>
	);
}

function CloseParseEditor(props) {
	return <FastField name={props.name}>{({ field, form }) => <CloseParseModal value={field.value} form={form} />}</FastField>;
}

function SaleDetector() {
	const { t } = useTranslation();
	return (
		<Tab.Pane>
			<Table definition>
				<Table.Header>
					<Table.Row>
						<Table.HeaderCell width={2} />
						<Table.HeaderCell>{t('value')}</Table.HeaderCell>
					</Table.Row>
				</Table.Header>
				<Table.Body>
					<TableLine title={t('saleDetector')} single>
						<div
							css={`
								display: flex;
								align-items: center;
								button {
									white-space: nowrap;
								}
							`}
						>
							<CloseParseEditor name="agent.__close_parse_config_data" />
							<TextInput title="English" name="agent.__close_parse_config_data.reg" />
						</div>
					</TableLine>
				</Table.Body>
			</Table>
		</Tab.Pane>
	);
}

// SpecialDays Tab Wrapper with Route
function SpecialDaysWrapper(props) {
	return <Route path="/settings/product/special-days" render={() => <SpecialDaysTab values={props.values} setFieldValue={props.setFieldValue} />} />;
}

function Configs(props) {
	const { t } = useTranslation();
	const CONFIG_PANES = [
		{
			menuItem: {
				as: NavLink,
				content: t('agentScreen'),
				to: '/settings/product/agent',
				key: 'agent',
			},
			render: () => <Route path="/settings/product/agent" component={AgentScreenConfigs} />,
		},
		{
			menuItem: {
				as: NavLink,
				content: t('workHours'),
				to: '/settings/product/time',
				key: 'time',
			},
			render: () => <Route path="/settings/product/time" component={() => <TimeConfigs values={props.values} />} />,
		},
		{
			menuItem: {
				as: NavLink,
				content: t('welcomeMessages'),
				to: '/settings/product/welcome',
				key: 'welcome',
			},
			render: () => <Route path="/settings/product/welcome" component={WelcomeConfigs} />,
		},
		{
			menuItem: {
				as: NavLink,
				content: t('saleDetector'),
				to: '/settings/product/sale',
				key: 'sale',
			},
			render: () => <Route path="/settings/product/sale" component={SaleDetector} />,
		},
	];

	const CONFIG_PANES_NO_SALE = [
		{
			menuItem: {
				as: NavLink,
				content: t('agentScreen'),
				to: '/settings/product/agent',
				key: 'agent',
			},
			render: () => <Route path="/settings/product/agent" component={AgentScreenConfigs} />,
		},
		{
			menuItem: {
				as: NavLink,
				content: t('workHours'),
				to: '/settings/product/time',
				key: 'time',
			},
			render: () => <Route path="/settings/product/time" component={TimeConfigs} />,
		},
		{
			menuItem: {
				as: NavLink,
				content: t('welcomeMessages'),
				to: '/settings/product/welcome',
				key: 'welcome',
			},
			render: () => <Route path="/settings/product/welcome" component={WelcomeConfigs} />,
		},
	];

	if (props.liveProduct && props.liveProduct.settings && props.liveProduct.settings.openSpecialDays) {
		CONFIG_PANES.push({
			menuItem: {
				as: NavLink,
				content: t('specialDays') || 'Özel Günler',
				to: '/settings/product/special-days',
				key: 'special-days',
			},
			render: () => <SpecialDaysWrapper values={props.values} setFieldValue={props.setFieldValue} />,
		});
		CONFIG_PANES_NO_SALE.push({
			menuItem: {
				as: NavLink,
				content: t('specialDays') || 'Özel Günler',
				to: '/settings/product/special-days',
				key: 'special-days',
			},
			render: () => <SpecialDaysWrapper values={props.values} setFieldValue={props.setFieldValue} />,
		});
	}
	let host = props.host;
	let Panes = host ? CONFIG_PANES : CONFIG_PANES_NO_SALE;
	const pathname = window.location.pathname;
	const defaultActiveIndex = React.useMemo(
		() =>
			Panes.findIndex((pane) => {
				return !!matchPath(pathname, {
					path: pane.menuItem.to,
					exact: true,
				});
			}),
		[pathname, Panes]
	);
	return (
		<Page.Wrap>
			<Tab menu={{ secondary: true, pointing: true }} activeIndex={defaultActiveIndex} panes={Panes} {...props} />
		</Page.Wrap>
	);
}

export default function ProductSettings() {
	const { response: userData } = useFetch('/api/auth/user', fetch_config, []);
	const { loading, response } = useFetch('/api/dahi/message/getLiveChat', fetch_config, []);
	//console.log('asd', response);
	const { t } = useTranslation();
	const LABELS = [
		{ key: 'amount', label: t('price'), color: 'green', parse: 'float' },
		{ key: 'code', label: t('code'), color: 'yellow' },
		{ key: 'quantity', label: t('Count'), color: 'blue', parse: 'int' },
	];
	let user = userData && userData.data;
	let liveProduct = user && user.data && user.data.products && _.find(user.data.products, { product_type: 'live' });
	const result = response && response.data && response.data.result;
	const initialValues = React.useMemo(() => {
		if (!result) return;
		const { messageSetting, staticOptions, agentOptions, workingSetting, client, workingHours } = result;
		const combined = _.assignIn(agentOptions, staticOptions);
		const agent = _.merge(
			{ attach: true, silent_agent: false, selectpopup: true, showSendStart: false, __close_parse_config: '' },
			_.pick(combined, [
				'emoji',
				'silent_agent',
				'selectpopup',
				'showSendStart',
				'__close_parse_config_data',
				'agentSellingData',
				'excel_create_phone',
				'hide_phone_view',
				'instagram_comments',
				'attach',
			])
		);
		// special_days'i staticOptions'dan al
		const special_days = staticOptions && staticOptions.special_days ? staticOptions.special_days : {};
		return { workingSetting, messageSetting, agent, client, workingHours, special_days };
	}, [result]);
	if (loading)
		return (
			<Page
				header={
					<Breadcrumb size="big">
						<Breadcrumb.Section as={Link} to={`/settings`}>
							<Icon name="setting" />
							{t('settings')}
						</Breadcrumb.Section>
						<Breadcrumb.Divider icon={{ name: 'asterisk', loading: true }} />
					</Breadcrumb>
				}
				flex
			>
				<MyMenu activeItem="general settings">
					<Page.Loader />
				</MyMenu>
			</Page>
		);
	let host = user.data.host === null || user.data.host === 'app.dialogtab.com';
	return (
		<Formik
			initialValues={initialValues}
			onSubmit={(values, actions) => {
				let clone = { ...values };
				clone.staticOptions = clone.agent;
				delete clone.agent;

				// special_days'i staticOptions'a ekle
				if (clone.special_days) {
					clone.staticOptions.special_days = clone.special_days;
					delete clone.special_days;
				}

				let data = clone.staticOptions && clone.staticOptions.__close_parse_config_data;
				if (data) {
					let list = [];
					_.each(data.found, (it) => {
						let label = _.find(LABELS, { key: it.key });
						list.push({ key: it.key, parse: label && label.parse });
					});
					clone.staticOptions.close_parser_config = data.reg
						? [
								{
									regex: data.reg,
									type: 'order',
									key: 'order',
									display: 'Sipariş Alındı:\nKod: {{code}}\nTutar: {{amount}}',
									version: 2,
									list: list,
								},
						  ]
						: [];
				}
				fetch('/api/dahi/channel/save', {
					method: 'POST',
					body: JSON.stringify({ channel: 'live', data: { set: clone } }),
					headers: {
						'Content-Type': 'application/json',
					},
				})
					.then((response) => {
						return response.json();
					})
					.then(() => {
						actions.resetForm(values);
						actions.setSubmitting(false);
					})
					.catch((e) => {
						console.error(e);
						actions.setSubmitting(false);
					});
			}}
		>
			{(props) => {
				return (
					<Page
						header={
							<Breadcrumb size="big">
								<Breadcrumb.Section as={Link} to={`/settings`}>
									<Icon name="setting" />
									{t('settings')}
								</Breadcrumb.Section>
								<Breadcrumb.Divider icon="right chevron" />
								<Breadcrumb.Section>{t('productSettings')}</Breadcrumb.Section>
							</Breadcrumb>
						}
						extra={
							<div className="ml-auto d-flex">
								<AccountProgress></AccountProgress>
								<Button loading={props.isSubmitting} primary type="submit" onClick={props.submitForm} style={{ marginLeft: '10px' }}>
									{t('saveChanges')}
								</Button>
							</div>
						}
						flex
					>
						<MyMenu activeItem="general settings">
							<form onSubmit={props.handleSubmit}>
								<Prompt
									when={props.dirty}
									message={(location) => (location.pathname.startsWith('/settings/product') ? true : t('questionWithoutSaving'))}
								/>
								<Configs {...props} host={host} liveProduct={liveProduct} />
							</form>
						</MyMenu>
					</Page>
				);
			}}
		</Formik>
	);
}
